module.exports = __webpack_public_path__ + "static/media/do_ziemi.95dbbc02.jpg";